import React from "react";
import brochure from "../../assets/icons/brochure.svg";
import indexCard from "../../assets/icons/indexCard.svg";
import form from "../../assets/icons/form.svg";
import clinicianBrochure from "../../assets/files/unity-confirm-provider-brochure.pdf";
import patientResourceCard from "../../assets/files/unity-confirm-patient-resource-card.pdf";
import normalResult from "../../assets/files/unity-confirm-cfc-negative-t18-v20260429.pdf";
import abnormalMosaicResult from "../../assets/files/unity-confirm-cfc-mosaic-xxy-v20260429.pdf";
import abnormalHighRiskResult from "../../assets/files/unity-confirm-cfc-positive-t21-v20260429.pdf";
import { useDeviceHook } from "../../utils/hooks/useDeviceHook";
import { ResourceDownloadItem } from "../../components/Resources/ResourceDownloadItem";
import { ResourcesInfoContainer } from "../../components/Resources/Resources.styles";
import {
  HelpPanelResourceCard,
  HelpPanelResourceSection,
  HelpPanelResourceTitle,
  HelpPanelResources,
} from "./Help.styles";

const resourceLinks = [
  {
    alt: "Brochure",
    icon: brochure,
    link: clinicianBrochure,
    title: "Clinician Brochure",
  },
  {
    alt: "Index Card",
    icon: indexCard,
    link: patientResourceCard,
    title: "Unity Patient Resource Card",
  },
];

const sampleReportLinks = [
  {
    alt: "Normal Result",
    icon: form,
    link: normalResult,
    title: "Normal Result",
  },
  {
    alt: "Abnormal Mosaic Result",
    icon: form,
    link: abnormalMosaicResult,
    title: "Abnormal Mosaic Result",
  },
  {
    alt: "Abnormal High Risk Result Confirmed",
    icon: form,
    link: abnormalHighRiskResult,
    title: "Abnormal High Risk Result Confirmed",
  },
];

const renderDownloadItem = ({
  alt,
  icon,
  link,
  title,
}: {
  alt: string;
  icon: string;
  link: string;
  title: string;
}) => (
  <ResourceDownloadItem
    key={title}
    alt={alt}
    icon={icon}
    title={title}
    links={[
      {
        label: "English",
        link,
        linkInNewWindow: true,
        isDownload: true,
      },
    ]}
  />
);

export const UnityConfirmResources = (): React.ReactElement => {
  const { deviceType } = useDeviceHook();

  return (
    <HelpPanelResources data-testid="unity-confirm-resources">
      <HelpPanelResourceSection>
        <HelpPanelResourceTitle>Resources</HelpPanelResourceTitle>
        <HelpPanelResourceCard>
          <ResourcesInfoContainer deviceType={deviceType} role="list">
            {resourceLinks.map(renderDownloadItem)}
          </ResourcesInfoContainer>
        </HelpPanelResourceCard>
      </HelpPanelResourceSection>
      <HelpPanelResourceSection>
        <HelpPanelResourceTitle>Sample Reports</HelpPanelResourceTitle>
        <HelpPanelResourceCard>
          <ResourcesInfoContainer deviceType={deviceType} role="list">
            {sampleReportLinks.map(renderDownloadItem)}
          </ResourcesInfoContainer>
        </HelpPanelResourceCard>
      </HelpPanelResourceSection>
    </HelpPanelResources>
  );
};
